import { ResourceProps } from 'react-admin';

const SoftwareChannelReleaseResource: ResourceProps = {
  name: 'channel_releases',
};

export default SoftwareChannelReleaseResource;
